export const BUILD_VERSION = '1779640170';
